import { OtpVerifyMethod } from 'mobileApp/system/model/otp'

/**
 * email、手機、身分證隱碼
 * @param value
 * @returns （範例以 ^ 替代 *）
 * 0912^^^678、abcd^^@gmail.com、A123^^^^89
 */
export function maskSensitive(value: string): string {
  if (!value) return value

  const trimmed = value.trim()

  // ===== Email =====
  if (trimmed.includes('@')) {
    const [account, domain] = trimmed.split('@')
    let maskedAccount = ''

    if (account.length <= 6) {
      // 小於等於 6 碼，隱藏後兩碼
      const visibleLen = Math.max(account.length - 2, 0)
      maskedAccount = account.slice(0, visibleLen) + '*'.repeat(account.length - visibleLen)
    } else {
      // 大於 6 碼，隱藏第 4、5、6 碼
      maskedAccount = account.slice(0, 3) + '***' + account.slice(6)
    }

    return maskedAccount + '@' + domain
  }

  // ===== 手機（09xxxxxxxx）=====
  if (/^09\d{8}$/.test(trimmed)) {
    return trimmed.slice(0, 4) + '****' + trimmed.slice(8)
  }

  // ===== 手機（+8869xxxxxxxx）=====
  if (/^\+8869\d{8}$/.test(trimmed)) {
    const local = '0' + trimmed.slice(4)
    return local.slice(0, 4) + '****' + local.slice(8)
  }

  // ===== 台灣身分證 =====
  if (/^[A-Z][12]\d{8}$/.test(trimmed)) {
    return trimmed.slice(0, 4) + '****' + trimmed.slice(8)
  }

  // ===== fallback =====
  return value
}

/**
 * OTP 驗證方式對應
 * @param email
 * @param phone
 * @returns
 */
export const getOtpMethod = (email: any, phone: any): OtpVerifyMethod => {
  const lookup = new Map<OtpVerifyMethod, any>([
    [OtpVerifyMethod.Email, email],
    [OtpVerifyMethod.SMS, phone],
  ])

  let result = OtpVerifyMethod.Unknown

  lookup.forEach((condition, method) => {
    if (condition && result === OtpVerifyMethod.Unknown) {
      result = method
    }
  })

  return result
}

export const removeObjEmptyVal = <T extends object>(obj: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined && value !== null && value !== '')
  ) as Partial<T>
